import React, { Component } from "react";
import axios from "axios";
import $ from 'jquery';
import {Link} from "react-router-dom";

import './Menu.scss';
import MyContext from '../MyContext.jsx';


class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount(){  
    this.context.loading(0);  
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="marketing_menu_container">
          <div className="page_header">
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Marketing</div>
          </div>
          <div className="menu_container">
            <Link className="single_menu_container" to="/home/brand">
              <div className="icon_container" style={{backgroundColor: "brown"}}>
                <i className="fab fa-artstation menu_icon"></i>
              </div>
              <div className="menu_label">New Brand</div>
            </Link>
            <Link className="single_menu_container" to="/home/product">
              <div className="icon_container" style={{backgroundColor: "#ae0bb3"}}>
                <i className="fab fa-buffer menu_icon"></i>
              </div>
              <div className="menu_label">New Product</div>
            </Link>
            <Link className="single_menu_container" to="/home/dealer">
              <div className="icon_container" style={{backgroundColor: "#5757ea"}}>
                <i className="fas fa-suitcase menu_icon"></i>
              </div>
              <div className="menu_label">Dealer</div>
            </Link>
            <Link className="single_menu_container" to="/home/influencer">
              <div className="icon_container" style={{backgroundColor: "orange"}}>
                <i className="fas fa-user-shield menu_icon"></i>
              </div>
              <div className="menu_label">Influencer</div>
            </Link>
            <Link className="single_menu_container" to="/home/influencer/feedback">
              <div className="icon_container" style={{backgroundColor: "red"}}>
                <i className="far fa-comment-alt menu_icon"></i>
              </div>
              <div className="menu_label">Influencer Feedback</div>
            </Link>
            <Link className="single_menu_container" to="/home/analysis">
              <div className="icon_container" style={{backgroundColor: "green"}}>
                <i className="fas fa-chart-area menu_icon"></i>
              </div>
              <div className="menu_label">Marketing Analysis</div>
            </Link>
          </div>
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Menu;
Menu.contextType = MyContext;
